import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import AnimatedDemoExtended from '../components/landing/AnimatedDemoExtended';
import AnimatedDemo from '../components/landing/AnimatedDemo';

function Capture30s() {
  const [started, setStarted] = useState(false);
  return (
    <div className="relative" style={{ zoom: 2, width: 960, height: 540 }}>
      <AnimatedDemo playing={started} loop={false} resetKey={started ? 1 : 0} />
      {!started && (
        <button onClick={() => setStarted(true)} className="absolute inset-0 z-30 bg-white" data-testid="capture-splash" aria-label="Iniciar captura" />
      )}
    </div>
  );
}

export default function DemoCapturePage() {
  const v = new URLSearchParams(useLocation().search).get('v');
  return (
    <div className="w-screen h-screen overflow-hidden bg-black" data-testid="demo-capture-page">
      {v === '30s' ? <Capture30s /> : <AnimatedDemoExtended loop={false} withAudio={false} capture />}
    </div>
  );
}
